import { PropsWithChildren, useEffect } from 'react'

export const IntercomTourAnchor = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    window.Intercom?.('update')
  }, [])

  return <>{children}</>
}
